import { Issue, IssueState, WorkLog } from "./types";

const getLatestWorkLogDate = (workLogs: WorkLog[] = [], state: IssueState) => {
  const timestamps = workLogs
    .filter((workLog) => workLog.nextState === state && workLog.createdAt)
    .map((workLog) => new Date(workLog.createdAt).getTime())
    .filter((timestamp) => !Number.isNaN(timestamp));

  if (timestamps.length === 0) return undefined;

  return new Date(Math.max(...timestamps)).toISOString();
};

export const getFilteredIssueDate = (issue: Issue) =>
  issue.state === IssueState.DONE
    ? (getLatestWorkLogDate(issue.workLogs, IssueState.DONE) ?? issue.createdAt)
    : issue.createdAt;
